import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Suspension = ({ suspension }: SpecProps<"suspension">) => {
  const { i18n } = useLingui();

  if (!suspension) {
    return null;
  }

  const suspensionFront = i18n.t({
    id: "itemPageLayout.keyInfo.suspension.front",
    message: "Suspension front",
    comment: "Field for 'Suspension front'for bus and truck in ad specification",
  });

  const suspensionRear = i18n.t({
    id: "itemPageLayout.keyInfo.suspension.rear",
    message: "Suspension rear",
    comment: "Field for 'Suspension rear'for bus and truck in ad specification",
  });

  return (
    <>
      <FieldValuePair field={suspensionFront} value={suspension.front} />
      <FieldValuePair field={suspensionRear} value={suspension.rear} />
    </>
  );
};
